import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular';
import { Diagnostic } from '@ionic-native/diagnostic';
 
 
@Injectable()
export class DevicePermissionsService {
 
    constructor(private platform: Platform, private diagnostic: Diagnostic) {
    }
 
    isAndroid() {
        return this.platform.is('android')
    }
 
    isiOS() {
        return this.platform.is('ios');
    }
 
    isUndefined(type) {
        return typeof type === "undefined";
    }
 
    checkCameraPermissions(): Promise<boolean> {
        return new Promise(resolve => {
            if (this.isiOS()) {
                this.diagnostic.getCameraAuthorizationStatus().then(status => {
                    if (status == this.diagnostic.permissionStatus.GRANTED) {
                        resolve(true);
                    }
                    else if (status == this.diagnostic.permissionStatus.DENIED) {
                        resolve(false);
                    }
                    else if (status == this.diagnostic.permissionStatus.NOT_REQUESTED || status.toLowerCase() == 'not_determined') {
                        this.diagnostic.requestCameraAuthorization().then(authorisation => {
                            resolve(authorisation == this.diagnostic.permissionStatus.GRANTED);
                        });
                    }                    
                });
            }
            else if (this.isAndroid()) {
                this.diagnostic.isCameraAuthorized().then(authorised => {
                    if (authorised) {
                        resolve(true);
                    }
                    else {
                        this.diagnostic.requestCameraAuthorization().then(authorisation => {
                            resolve(authorisation == this.diagnostic.permissionStatus.GRANTED);
                        });
                    }
                });
            }
        });
    }
    
}


// WEBPACK FOOTER //
// ./src/services/device-permissions.ts